import React, { memo, useState } from 'react';
import { Dropdown } from 'tea-component';
import CardIconButton from '@/pages/datalab/components/ChartCardIconButtons/CardIconButton';
import SvgIcon from '@home/components/SvgIcon';

interface IOperationDropdownIconProps {
  children: React.ReactNode;
}

const OperationDropdownIcon: React.FC<IOperationDropdownIconProps> = (props) => {
  const { children } = props;
  const [open, setOpen] = useState<boolean>(false);

  // 不包裹 useMemo：JSX 创建开销极低，且组件外层已有 memo 保护；
  // 只有当 buttonNode 包含复杂子树且性能测试确认是瓶颈时，才值得优化
  const buttonNode = (
    <CardIconButton active={open}>
      <SvgIcon type="there-points" />
    </CardIconButton>
  );

  return (
    <Dropdown
      clickClose
      boxClassName="dbl-card-drag-operation-dropdown"
      button={buttonNode}
      open={open}
      appearance="pure"
      placement="bottom-end"
      onOpenChange={setOpen}
    >
      {children}
    </Dropdown>
  );
};

export default memo(OperationDropdownIcon);
